import React from 'react';
import '../../App.css'
import HeroSection from '../HeroSection';
import Home from '../Home';
import Cards from '../Cards';
import Footer from '../Footer';

function HomePage() {
    return (
        <>
            <HeroSection />
            <Home />
        </>
    )
}

export default HomePage;